export default function ValidationErrors({ errors, centerText = false }) {
    return (
        Object.keys(errors).length > 0 && (
            <div className="mb-2" style={centerText ? { textAlign: 'center' } : {}}>
                <ul className="ul-unstyled color color-error p1">
                    {Object.keys(errors).map(function (key, index) {
                        return <li key={index}>{errors[key]}</li>;
                    })}
                </ul>
            </div>
        )
    );
}
